import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';
import type { dynamicObj } from 'src/pages/assets';

export default class SupplierExportCongApiService extends AbstractApiService {
  public constructor() {
    super({});
  }
  public async getSupplierExport(): Promise<any> {
    return super.get(api.get_supplier_export_config);
  }
  public async downloadApiConfig(data: dynamicObj): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(api.supplier_export_config + '?' + querystring, {
      responseType: 'blob',
    });
  }
  public async submitExportConfig(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.put(api.save_supplier_export_config, formData);
  }
  public async submitUSeDefault(): Promise<any> {
    const formData = new FormData();
    return super.put(api.use_default_export_config, formData);
  }
}
